<div class="max-width-500">
  <form
    [formGroup]="loginForm"
    (ngSubmit)="doLogin()"
  >
    <ion-grid fixed="true">
      <ion-row>
        <ion-col size="12">
          <div class="login-box block-content-round">
            <lib-login-logo></lib-login-logo>
            @if (APP_NAME_TAGLINE) {
              <div class="app-name-tagline">
                <span>{{ APP_NAME_TAGLINE | translate }}</span>
              </div>
            }

            <ion-list lines="none">
              <ion-item>
                <ion-input
                  formControlName="username"
                  label="{{ 'login.labels.user_name' | translate }}"
                  labelPlacement="floating"
                  placeholder="{{ 'login.place_holder.user_name' | translate }}"
                  fill="outline"
                  mode="md"
                  [clearInput]="true"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  formControlName="password"
                  type="password"
                  label="{{ 'login.labels.password' | translate }}"
                  labelPlacement="floating"
                  placeholder="{{ 'login.place_holder.password' | translate }}"
                  fill="outline"
                  mode="md"
                >
                  <ion-input-password-toggle slot="end"></ion-input-password-toggle>
                </ion-input>
              </ion-item>

              @if (errorMessage()) {
                <ion-item>
                  <div class="errors">
                    {{ errorMessage() }}
                  </div>
                </ion-item>
              }

              @if (isDesktopView()) {
                <div class="ion-padding-horizontal">
                  <ion-button
                    expand="block"
                    type="submit"
                    fill="solid"
                    size="default"
                    [disabled]="isOffline()"
                  >
                    {{ 'login.general' | translate }}
                  </ion-button>
                </div>
              }

              <p class="ion-text-center fs-xs ion-padding-vertical">
                {{ 'login.access' | translate }}
                <a
                  [href]="LEGAL_LINKS.termsUrl"
                  target="_blank"
                >
                  {{ 'login.conditions' | translate }}
                </a>
                {{ 'login.and' | translate }}
                <a
                  [href]="LEGAL_LINKS.privacyUrl"
                  target="_blank"
                >
                  {{ 'login.policy' | translate }}
                </a>
                .
              </p>

              <ion-item lines="none">
                <ion-label class="ion-text-center fs-sm">
                  <a [routerLink]="['/recover-password']">{{ 'login.remember_password' | translate }}</a>
                </ion-label>
              </ion-item>

              <ion-button
                expand="block"
                fill="outline"
                [routerLink]="['/registration']"
                >{{ 'login.register' | translate }}</ion-button
              >
            </ion-list>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</div>
